module.exports = __webpack_public_path__ + "static/media/003-charity.b8febb72.svg";